// extracted by mini-css-extract-plugin
export default {"connectWalletPage":"ConnectWalletPage_connectWalletPage__szATY","fadeInUp":"ConnectWalletPage_fadeInUp__G9ASA"};